import api from '@/utils/api';

/**
 * get company api
 *
 * @param {string} companyId The company id
 * @returns {Promise} The promise object of the api call
 */
const getCompanyApi = (companyId) => api.get(`company/${companyId}`);
export default getCompanyApi;
